module.exports = __webpack_public_path__ + "static/media/FSElliotPro-Bold.0e3804a2.ttf";